package top.wcpe.allincore.layout.engine

import kotlin.jvm.JvmField
import kotlin.jvm.JvmStatic

/**
 * 尺寸描述：长度像素值、百分比、自动。
 */
interface Dimension {

    /**
     * 像素长度。
     *
     * ADR-0034：保留「public final 字段 + 同名访问器」双形态，下游两种用法零改动。
     */
    class Px(@JvmField val value: Float) : Dimension {

        fun value(): Float = value

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            if (other !is Px) return false
            // 逐位比较（等价 Java Float.compare == 0）
            return other.value.toBits() == value.toBits()
        }

        override fun hashCode(): Int {
            // 逐位复刻原 Java Objects.hash(value)
            return 31 + value.hashCode()
        }

        override fun toString(): String {
            return "Px[value=$value]"
        }
    }

    /**
     * 百分比，取值范围由实现自行约束（例如 0~100 或 0~1，本模块约定 0~100）。
     *
     * ADR-0034：保留「public final 字段 + 同名访问器」双形态，下游两种用法零改动。
     */
    class Percent(@JvmField val value: Float) : Dimension {

        fun value(): Float = value

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            if (other !is Percent) return false
            // 逐位比较（等价 Java Float.compare == 0）
            return other.value.toBits() == value.toBits()
        }

        override fun hashCode(): Int {
            // 逐位复刻原 Java Objects.hash(value)
            return 31 + value.hashCode()
        }

        override fun toString(): String {
            return "Percent[value=$value]"
        }
    }

    /** 自动尺寸。 */
    class Auto : Dimension {

        override fun equals(other: Any?): Boolean {
            if (this === other) return true
            return other is Auto
        }

        override fun hashCode(): Int {
            // 复刻原 Java Objects.hash()（空参 = Arrays.hashCode(new Object[0]) = 1）
            return 1
        }

        override fun toString(): String {
            return "Auto[]"
        }
    }

    companion object {

        @JvmField
        val AUTO: Auto = Auto()

        @JvmStatic
        fun px(value: Float): Dimension {
            return Px(value)
        }

        @JvmStatic
        fun percent(value: Float): Dimension {
            return Percent(value)
        }

        @JvmStatic
        fun auto(): Dimension {
            return AUTO
        }
    }
}
